var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.886 11.653c.017-.13.053-.26.107-.385l.3-.695V4.457a1.457 1.457 0 1 0-2.913 0V10L7.86 4.603a1.456 1.456 0 1 0-2.805.791l1.917 6.798M15.705 10.138c.32-.738-.054-1.624-.792-1.944a1.458 1.458 0 0 0-1.916.759l-.702 1.62",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.598 13.082v.006l.757-1.745a1.458 1.458 0 0 0-2.674-1.158l-.913 2.108a1.488 1.488 0 0 1 .163 1.023",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.932 13.316a1.497 1.497 0 0 1-.184.481 1.458 1.458 0 0 0 2.605-.139l.247-.57v-.006",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.748 13.796c.088-.146.15-.31.184-.481",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.934 13.316a1.515 1.515 0 0 0-.164-1.023l-.026-.045a1.502 1.502 0 0 0-1.41-.717l-1.038.088-.409.034-4.279.362a1.759 1.759 0 0 0-1.604 1.9l.016.181v-.002l.09 1.06-.09-1.058.104 1.25C6.29 18.475 8.8 21 11.931 21c3.131 0 5.67-2.533 5.67-5.657v-2.255l-.247.57a1.457 1.457 0 0 1-2.606.14c-.24.4-.661.682-1.162.725l-1.494.126-1.704.144.276.562.522 1.062",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingers);
export default __webpack_public_path__ + "static/media/fingers.abb2a61b.svg";
export { ForwardRef as ReactComponent };